import { render, staticRenderFns } from "./PrestationTagForm.vue?vue&type=template&id=fbb3b9e2&scoped=true"
import script from "./PrestationTagForm.vue?vue&type=script&lang=js"
export * from "./PrestationTagForm.vue?vue&type=script&lang=js"
import style0 from "./PrestationTagForm.vue?vue&type=style&index=0&id=fbb3b9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb3b9e2",
  null
  
)

export default component.exports